export default "__VITE_ASSET__jFQAr_6c__"